import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CandidateContactCard = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '370px',
    height: 'max-content',
    backgroundColor: palette.white,
    padding: '24px',
    borderRadius: '24px',
    position: 'sticky',
    top: '24px',

    [theme.breakpoints.down('laptop')]: {
      position: 'fixed',
      width: '100%',
      bottom: 0,
      left: '50%',
      top: 'initial',
      transform: 'translateX(-50%)',
      borderRadius: '24px 24px 0 0',
      boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.1)',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      borderRadius: '0',
      left: '0',
      transform: 'translateX(0)',
    },
  };
});

export const CandidateContactCardHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '5px',
  };
});

export const CandidateContactCardHeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',
    whiteSpace: 'pre-line',
  };
});

export const CandidateContactCardHeaderStatus = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.alerts.error,
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '128%',
    backgroundColor: palette.alerts.error_light,
    padding: '8px 20px',
    borderRadius: '8px',
  };
});

export const CandidateContactCardMain = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '13px',
  };
});

export const CandidateContactCardMainItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',

    '> p': {
      color: palette.text.body,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '136%',
    },
  };
});

export const FeedbackContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor: '#FFF1F1',
    borderRadius: '12px',
    padding: '16px',
  };
}) as typeof Box;

export const FeedbackContentItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    '> svg': {
      flexShrink: 0,
    },
  };
}) as typeof Box;
